import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusWarningTriangle.tsx
const IconApplicationStatusWarningTriangle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "m10.722 2.5 7.938 13.75a.834.834 0 0 1-.721 1.25H2.062a.834.834 0 0 1-.722-1.25L9.278 2.5a.833.833 0 0 1 1.444 0M9.167 13.334V15h1.667v-1.666zm0-5.834v4.167h1.667V7.5z"
	})]
});
var IconApplicationStatusWarningTriangle_default = forwardRef(IconApplicationStatusWarningTriangle);
//#endregion
export { IconApplicationStatusWarningTriangle_default as default };
